import { useTranslation } from "react-i18next"
import HasPermission, { CanViewCompanyLog } from "app/PermissionChecker"
import DailyActivityChart from "./DailyActivityChart"
import ModuleActivityChart from "./ModuleActivityChart"
import { Link } from "react-router-dom"
import Loading from "components/commons/Loading"
import { getModuleColor } from "app/Module"


function ActivityStats({
    data,
    isLoading = false,
    onChangeDaysNumber = (days) => { }
}) {

    const [t] = useTranslation("global")
    const canViewCompanyLog = HasPermission(CanViewCompanyLog)

    let content

    content =
        <div className={`card bg-black bg-opacity-10 text-white mb-4 ${isLoading ? "opacity-25" : ""}`}>
            <div className="card-body text-center ">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="text-muted"><i className="fa-solid fa-chart-line"></i> {t("helper.activities_in_last_n_day", { count: data.dates })}</h4>
                    {isLoading && <Loading />}
                    <select
                        className="form-select w-auto"
                        value={data.dates}
                        onChange={(e) => onChangeDaysNumber(Number(e.target.value))}
                    >
                        <option value={7}>{t("time.last_n_days", { days: 7 })}</option>
                        <option value={14}>{t("time.last_n_days", { days: 14 })}</option>
                        <option value={28}>{t("time.last_n_days", { days: 28 })}</option>
                    </select>
                </div>

                <div className="row">
                    <div className="col-sm-9 ">
                        <DailyActivityChart data={data.activityPerDay} />
                    </div>
                    <div className="col-sm-3 pt-2">
                        <div className=" ">
                            {t("unit.daily_activity")}<br />
                            <h2>{data.DailyAverage}</h2>
                            <br />
                            <ModuleActivityChart
                                data={
                                    [
                                        {
                                            name: "CORE",
                                            value: data.activityPerModule["CORE"],
                                            color: getModuleColor("CORE")
                                        },
                                        {
                                            name: "HR",
                                            value: data.activityPerModule["HR"],
                                            color: getModuleColor("HR")
                                        },
                                        {
                                            name: "WHISTLE",
                                            value: data.activityPerModule["WHISTLE"],
                                            color: getModuleColor("WHISTLE")
                                        },
                                        {
                                            name: "ADMIN",
                                            value: data.activityPerModule["ADMIN"],
                                            color: getModuleColor("ADMIN")
                                        },
                                        {
                                            name: "HEALTH",
                                            value: data.activityPerModule["HEALTH"],
                                            color: getModuleColor("HEALTH")
                                        },
                                        {
                                            name: "SAFETY",
                                            value: data.activityPerModule["SAFETY"],
                                            color: getModuleColor("SAFETY")
                                        },
                                        {
                                            name: "DEVICES",
                                            value: data.activityPerModule["DEVICES"],
                                            color: getModuleColor("DEVICES")
                                        }
                                    ]
                                }
                            />
                        </div>
                    </div>
                </div>
                {
                    canViewCompanyLog &&
                    <div className="row text-end">
                        <Link to={{ pathname: "/dashboard/log" }} className="nav-link"><button className="btn btn-dark me-2"><i className="fa-solid fa-eye"></i> {t("menu.log")} </button></Link>
                    </div>
                }

            </div>
        </div>

    return content

}

export default ActivityStats